<template>
  <a-link
    v-if="tag"
    class="tag"
    :to="generateTagPath(tag)"
    :trailing-slash="!isMigratedTag"
  >
    <a-icon
      :icon="ICON.TAG"
      :width="14"
      :height="14"
      original
      class="tag__icon"
    />
    <span class="tag__name text-medium bold">{{ tag.name }}</span>
  </a-link>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'
import AIcon, { ICON } from 'shared/AIcon'
import { checkIfMigratedTag } from 'enums/tags'

export default {
  name: 'ATag',
  mixins: [mixins.urlGenerators],
  components: { AIcon },
  props: {
    tag: propValidator([PROP_TYPES.OBJECT], false)
  },
  data() {
    return { ICON }
  },
  computed: {
    isMigratedTag() {
      const { slug } = this.$helper.processResponse(this.tag)
      return checkIfMigratedTag(slug)
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  align-items: center;
  font-size: 0;
}

.tag__icon {
  margin-right: 4px;
}

.tag__name {
  font-weight: 700;
  color: $c--mid-purple;
}

.tag:hover {
  /deep/ .tag__icon svg {
    fill: $c--main;
  }

  .tag__name {
    color: $c--main;
  }
}
</style>
